var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.314 2l.942.943L2.943 14.257 2 13.314 13.314 2z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.28 13.333l-.942.943L2.024 2.962l.943-.942L14.28 13.333z",
    fill: "inherit"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjMxMzYgMkwxNC4yNTY0IDIuOTQyODFMMi45NDI2OSAxNC4yNTY1TDEuOTk5ODggMTMuMzEzN0wxMy4zMTM2IDJaIiBmaWxsPSJpbmhlcml0Ii8+CjxwYXRoIGQ9Ik0xNC4yODA1IDEzLjMzMzNMMTMuMzM3NyAxNC4yNzYxTDIuMDI0MDMgMi45NjI0M0wyLjk2Njg0IDIuMDE5NjJMMTQuMjgwNSAxMy4zMzMzWiIgZmlsbD0iaW5oZXJpdCIvPgo8L3N2Zz4K";
export { SvgCross as ReactComponent };